<div class="datetime-picker">
  <dojo-date-filter-button
    [control]="dateCtrl"
    [placeholder]="placeholder()"
    [errorStateMatcher]="childErrorStateMatcher()"
    [min]="min()"
    [max]="max()"
    [size]="size()"
  />
  <dojo-time-picker-button
    [control]="timeCtrl"
    [placeholder]="timePlaceholder()"
    [errorStateMatcher]="childErrorStateMatcher()"
    [size]="size()"
  />
</div>
